export default "__VITE_ASSET__CfpJBUf1__"